import React, { useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogActions } from '@mui/material';
import Footer from '../cards/Footer';
import { getMarkDown, useDetectIOS, useDetectAndroid } from '../utils';
import '../../../stylesheets/triagebot/Dialog.scss';

const EVisitConfirmation = ({ message, setshowCommonReasonEVisitChangeOverDialog, showCommonReasonEVisitChangeOverDialog, setIsTriageOver }) => {

    const {isIOS} = useDetectIOS();
    const {isAndroid} = useDetectAndroid();

    const dialogHeaderRef = useRef(null);

    const changeoverPromptData = message?.data?.[1]?.changeoverPrompt?.data || [];
    const externalSchedulingUrl = changeoverPromptData?.[1]?.externalSchedulingUrl;
    let csnValue = '';
    if (externalSchedulingUrl) {
        try {
            const params = new URLSearchParams(new URL(externalSchedulingUrl).search);
            csnValue = params.get('csn') || '';
        } catch (error) {
            csnValue = '';
        }
    }
    const iOSEvisitURL = changeoverPromptData?.[1]?.iOSEvisitURL?.replace('${csnValue}', csnValue);
    const androidEvisitURL = changeoverPromptData?.[1]?.androidEVisitURL?.replace('${csnValue}', csnValue);

    const headerText = changeoverPromptData?.[0]?.headerText || '';
    const evisitInfo = changeoverPromptData?.[1]?.evisitInfo || {};
    const bodyText = evisitInfo?.textJ || '';
    const bodyBulletText = evisitInfo?.textL || '';
    const continueSchedulingText = changeoverPromptData?.[0]?.nextButton?.displayText || 'Continue to MyChart';

    const handleClose = () => {
        if (setshowCommonReasonEVisitChangeOverDialog instanceof Function) {
            setshowCommonReasonEVisitChangeOverDialog(false);
        }

    }

    const handleRedirectComplete = () => {
        window.dispatchEvent(new CustomEvent('evisit-redirected'));
        handleClose();

        if (setIsTriageOver instanceof Function) {
            setIsTriageOver(true);
        }
    }

    useEffect(() => {
        const element = document.getElementsByClassName('loader');
        if (element && element?.length > 0) {
            element[0].style.visibility = "hidden"; // Set visibility to hidden
        }
    }, [])

    // Move screen reader focus to the dialog header when the dialog opens.
    useEffect(() => {
        if (showCommonReasonEVisitChangeOverDialog) {
            setTimeout(() => {
                dialogHeaderRef.current?.focus();
            }, 0);
        }
    }, [showCommonReasonEVisitChangeOverDialog]);

    const RedirectDeepLink = () => {
        let redirected = false;

        if (isIOS && iOSEvisitURL) {
            window.location.href = iOSEvisitURL;
            redirected = true;
        }
        else if (isAndroid && androidEvisitURL) {
            window.location.href = androidEvisitURL;
            redirected = true;
        }
        else if (externalSchedulingUrl) {
           window.open(`${externalSchedulingUrl}`);
           redirected = true;
        }

        if (redirected) {
            handleRedirectComplete();
        }
    }

    return (
        <Dialog
            id='change-dialog'
            open={showCommonReasonEVisitChangeOverDialog}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    handleClose();
                }
            }}
            disableEscapeKeyDown
            PaperProps={{
                className:'Evisit-dialog Changeover-dialog new-evisit-changeover-dialog'
            }}
        >
            <div id="dialog-title" className='changeOver-Header'>
                <b
                    className='headerTextCommon'
                    ref={dialogHeaderRef}
                    tabIndex='-1'
                >
                    {headerText}
                </b>
            </div>
            <DialogContent>
                <div className='changeOver-PopupBody' tabIndex='0'>
                    <div className='ContentStyle'>
                        {getMarkDown(bodyText)}
                        <div className='body-bullet-text'>{bodyBulletText}</div>
                    </div>
                </div>
            </DialogContent>

            <DialogActions id="dialog-footer">
                <Footer>
                    <button
                        className='button-item'
                        onClick={RedirectDeepLink}
                    >
                        <span>{continueSchedulingText}</span>
                        <svg className='new-evisit-arrow' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">
                            <path d="M4.16732 10.8335H13.4757L9.40898 14.9002C9.08398 15.2252 9.08398 15.7585 9.40898 16.0835C9.73398 16.4085 10.259 16.4085 10.584 16.0835L16.0757 10.5918C16.4007 10.2668 16.4007 9.74185 16.0757 9.41685L10.5923 3.91685C10.2673 3.59185 9.74232 3.59185 9.41732 3.91685C9.09232 4.24185 9.09232 4.76685 9.41732 5.09185L13.4757 9.16685H4.16732C3.70898 9.16685 3.33398 9.54185 3.33398 10.0002C3.33398 10.4585 3.70898 10.8335 4.16732 10.8335Z" fill="white"/>
                        </svg>
                    </button>
                </Footer>
            </DialogActions>
        </Dialog>
    )
}

export default EVisitConfirmation;
